/* Luxury Box nav drawer — takes over the theme's hamburger button and the old
   "Shop by Brand" link. "Your size" is saved in localStorage (lb_size) and read by
   assets/luxbox-collection.js; nothing is ever converted between US and EU. */
(function () {
  'use strict';
  var SIZE_KEY = 'lb_size';
  var KEYS = ['us', 'eu', 'apparel', 'waist'];

  function readSize() { try { return JSON.parse(localStorage.getItem(SIZE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function writeSize(s) { try { localStorage.setItem(SIZE_KEY, JSON.stringify(s)); } catch (e) {} }

  function init(root) {
    if (!root || root.dataset.lbnInit) return;
    root.dataset.lbnInit = '1';
    var drawer = root.querySelector('[data-lbn]');
    if (root.dataset.stockLinks === 'true') {
      root.querySelectorAll('a[href^="/collections/"]').forEach(function (a) {
        var h = a.getAttribute('href');
        if (h.indexOf('?') === -1 && h.indexOf('#') === -1) a.setAttribute('href', h + '?filter.v.availability=1');
      });
    }
    var scrim = root.querySelector('[data-lbn-scrim]');
    var scroller = root.querySelector('[data-lbn-scroll]');
    var closeBtn = root.querySelector('[data-lbn-close]');
    var lastFocus = null, sizeDirty = false, isOpen = false;

    // thousands separators for counts rendered by Liquid
    root.querySelectorAll('[data-lbn-n]').forEach(function (el) {
      var n = parseInt(el.textContent.replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) el.textContent = n.toLocaleString();
    });

    // ---------- open / close ----------
    function open(target) {
      if (isOpen) return;
      isOpen = true; sizeDirty = false;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lbn-open');
      renderSize();
      var el = target ? root.querySelector('#lbn-' + target) : null;
      if (el && scroller) { setTimeout(function () { scroller.scrollTop = el.offsetTop - 14; }, 60); }
      else if (scroller) scroller.scrollTop = 0;
      setTimeout(function () { closeBtn && closeBtn.focus({ preventScroll: true }); }, 80);
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lbn-open');
      closePickers();
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      if (sizeDirty) { sizeDirty = false; window.dispatchEvent(new CustomEvent('lb:size:commit', { detail: readSize() })); }
    }

    // Take over the theme's hamburger (capture phase, before Pipeline's own handler)
    // and the old brand page link. Anything inside the theme's own drawer is left alone.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var burger = t.closest('[data-drawer-toggle="hamburger"]');
      if (burger && !burger.closest('[data-drawer="hamburger"]')) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
      var brand = t.closest('a[href*="/pages/brand"], [data-lb-nav-brands]');
      if (brand && !root.contains(brand)) { e.preventDefault(); e.stopImmediatePropagation(); open('brands'); return; }
      var size = t.closest('[data-lb-nav-open]');
      if (size && !root.contains(size)) { e.preventDefault(); e.stopImmediatePropagation(); open('size'); return; }
    }, true);
    scrim.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    // ---------- your size ----------
    function renderSize() {
      var s = readSize();
      KEYS.forEach(function (k) {
        var val = root.querySelector('[data-lbn-val="' + k + '"]');
        var cell = root.querySelector('[data-lbn-pick="' + k + '"]');
        if (val) val.textContent = s[k] ? s[k] : '–';
        if (cell) cell.classList.toggle('is-set', !!s[k]);
        root.querySelectorAll('[data-lbn-picker="' + k + '"] [data-lbn-opt]').forEach(function (b) { b.classList.toggle('is-on', String(s[k]) === b.dataset.lbnOpt); });
      });
      var any = KEYS.some(function (k) { return !!s[k]; });
      root.querySelectorAll('[data-lbn-reset]').forEach(function (b) { b.hidden = !any; });
      root.querySelectorAll('[data-lbn-sizehint]').forEach(function (h) { h.hidden = any; });
    }
    function closePickers() {
      root.querySelectorAll('[data-lbn-picker]').forEach(function (p) { p.hidden = true; });
      root.querySelectorAll('[data-lbn-pick]').forEach(function (c) { c.classList.remove('is-editing'); c.setAttribute('aria-expanded', 'false'); });
    }
    function setSize(k, v) {
      var s = readSize();
      if (v === null || String(s[k]) === String(v)) delete s[k]; else s[k] = v;
      writeSize(s); sizeDirty = true; renderSize();
      window.dispatchEvent(new CustomEvent('lb:size', { detail: s }));
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      var pick = t.closest('[data-lbn-pick]');
      if (pick) {
        var k = pick.dataset.lbnPick;
        var picker = root.querySelector('[data-lbn-picker="' + k + '"]');
        var wasOpen = picker && !picker.hidden;
        closePickers();
        if (picker && !wasOpen) { picker.hidden = false; pick.classList.add('is-editing'); pick.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var opt = t.closest('[data-lbn-opt]');
      if (opt) { var pk = opt.closest('[data-lbn-picker]').dataset.lbnPicker; setSize(pk, opt.dataset.lbnOpt || null); closePickers(); return; }
      var reset = t.closest('[data-lbn-reset]');
      if (reset) {
        var cur = readSize(); reset.dataset.lbnReset.split(',').forEach(function (k) { delete cur[k]; });
        writeSize(cur); sizeDirty = true; renderSize(); closePickers();
        window.dispatchEvent(new CustomEvent('lb:size', { detail: cur }));
        return;
      }
      var tile = t.closest('[data-lbn-tile]');
      if (tile) {
        var idx = tile.dataset.lbnTile, sub = root.querySelector('[data-lbn-sub="' + idx + '"]');
        var opening = sub && !sub.classList.contains('is-open');
        root.querySelectorAll('[data-lbn-sub]').forEach(function (x) { x.classList.remove('is-open'); });
        root.querySelectorAll('[data-lbn-tile]').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); });
        if (opening) { sub.classList.add('is-open'); tile.classList.add('is-open'); tile.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var jump = t.closest('[data-lbn-jump]');
      if (jump) { var g = root.querySelector('[data-lbn-letter="' + jump.dataset.lbnJump + '"]'); if (g && scroller) scroller.scrollTo({ top: g.offsetTop - 10, behavior: 'smooth' }); return; }
    });

    renderSize();
    window.LuxboxNav = { open: open, close: close, readSize: readSize };
  }

  function boot() { document.querySelectorAll('[data-section-type="luxbox-nav"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
